import executeQuery from "#lib/db"

export const getFavorites = async ({ userID }: { userID: string }) => {
	const list = await executeQuery({
		query: `select * from favorites where userID=${userID}`,
	})

	return list
}

export const addFavorite = async ({ userID, recipeID }: { userID: string; recipeID: string }) => {
	const query = `insert into favorites (userID, recipeID) values (${userID}, ${recipeID})`
	await executeQuery({ query })

	return null
}

export const deleteFavorite = async ({ userID, recipeID }: { userID: string; recipeID: string }) => {
	const query = `delete from favorites where userID=${userID} and recipeID=${recipeID}`
	await executeQuery({ query })

	return null
}
